// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2e5Md","description":"styles_description__2LUyb","content":"styles_content__yty3D","button":"styles_button__2Uzb1"};